module.exports = __webpack_public_path__ + "static/media/logoergo.a6c9d762.jpg";